export const state = () => ({
    termAndConditions: {},
    settings: {},
    creditTiers: [],
    creditTierRewards: [],
    itemTiers: [],
    itemTierRewards: [],
})

export const actions = {
    async getTermAndConditions({ commit }, params) {
        await this.$axios
            .get(`/players-reward/rewards-control/tnc`, { params })
            .then((data) => {
                commit('setTermAndConditions', data?.data?.data)
                return true
            })
            .catch((_) => {
                return false
            })
    },
    async updateTermAndConditions({ _ }, body) {
        const response = await this.$axios
            .put(`/players-reward/rewards-control/tnc`, body, {
                params: {},
            })
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async getSettings({ commit }, params) {
        await this.$axios
            .get(`/players-reward/rewards-control/settings`, { params })
            .then((data) => {
                commit('setSetting', data?.data?.data)
                return true
            })
            .catch((_) => {
                return false
            })
    },
    async updateSettings({ _ }, body) {
        const response = await this.$axios
            .put(`/players-reward/rewards-control/settings`, body, {
                params: {},
            })
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async getCreditTiers({ commit }, params) {
        const response = await this.$axios
            .get(`/players-reward/rewards-control/credit/tiers`, { params })
            .then((data) => {
                commit('setCreditTiers', data?.data?.data)
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async updateCreditTiers({ _ }, body) {
        const response = await this.$axios
            .put(`/players-reward/rewards-control/credit/tiers`, body, {
                params: {},
            })
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async getCreditTiersRewards({ commit }, params) {
        const response = await this.$axios
            .get(`/players-reward/rewards-control/credit/tiers/rewards`, {
                params,
            })
            .then((data) => {
                commit('setCreditTierRewards', data?.data?.data)
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async getItemTiersRewards({ commit }, params) {
        const response = await this.$axios
            .get(`/players-reward/rewards-control/item/tiers/rewards`, {
                params,
            })
            .then((data) => {
                commit('setCreditTierRewards', data?.data?.data)
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async updateCreditTiersRewards({ _ }, { id, body }) {
        const response = await this.$axios
            .put(
                `/players-reward/rewards-control/credit/tiers/rewards/${id}`,
                body,
                {
                    params: {},
                }
            )
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async deleteCreditTiersRewards({ _ }, id) {
        const response = await this.$axios
            .delete(
                `/players-reward/rewards-control/credit/tiers/rewards/${id}`,
                {
                    params: {},
                }
            )
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async getItemTiers({ commit }, params) {
        const response = await this.$axios
            .get(`/players-reward/rewards-control/item/tiers`, { params })
            .then((data) => {
                commit('setItemTiers', data?.data?.data)
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async updateItemTiers({ _ }, body) {
        const response = await this.$axios
            .put(`/players-reward/rewards-control/item/tiers`, body, {
                params: {},
            })
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async updateItemTiersRewards({ _ }, { id, body }) {
        const response = await this.$axios
            .put(
                `/players-reward/rewards-control/item/tiers/rewards/${id}`,
                body,
                {
                    params: {},
                }
            )
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async deleteItemTierReward({ _ }, rewardId) {
        const response = await this.$axios
            .delete(
                `/players-reward/rewards-control/item/tiers/rewards/${rewardId}`
            )
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async createItemTierReward({ _ }, { tierId, body }) {
        const response = await this.$axios
            .post(
                `/players-reward/rewards-control/item/tiers/rewards/${tierId}`,
                body
            )
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async createCreditTierReward({ _ }, { tierId, body }) {
        const response = await this.$axios
            .post(
                `/players-reward/rewards-control/credit/tiers/rewards/${tierId}`,
                body
            )
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
}

export const mutations = {
    setTermAndConditions(state, payload) {
        state.termAndConditions = payload
    },
    setSetting(state, payload) {
        state.settings = payload
    },
    setCreditTiers(state, payload) {
        state.creditTiers = payload
    },
    setCreditTierRewards(state, payload) {
        state.creditTierRewards = payload
    },
    setItemTiers(state, payload) {
        state.itemTiers = payload
    },
}
